import { render } from "./Window.vue?vue&type=template&id=859e9ce4&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"

import "./Window.vue?vue&type=style&index=0&id=859e9ce4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859e9ce4"]])

export default __exports__